import { useTranslation } from "react-i18next";
import styles from "../styles/profile.module.scss";
import MySubscriptionsCard from "./MySubscriptionsCard";
import { useDispatch } from "react-redux";
import { setOpenModal } from "../../../store/slices/modals.slice";
import { useAppSelector } from "../../../store/store";
import { ROUTES } from "../../../constants/routes";
import { useNavigate } from "react-router-dom";

interface IProps {
  planId: number;
  nextPay: string;
  currentOrder: any;
  isSubscribed: boolean;
  chooseSubscription: (tab: number) => void;
}
const MySubscriptions = ({ planId, nextPay, currentOrder, isSubscribed, chooseSubscription }: IProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  console.log(nextPay, "nextPay");
  const subscriptionsList = useAppSelector((state: any) => state.subscriptions.subscriptionsList);
  const userData = useAppSelector((state: any) => state.auth.userData);

  const removeSubscriptionHandler = () => {
    dispatch(setOpenModal("removeSubscription"));
  };

  return (
    <div>
      {currentOrder?.status === "pending" && <div className={styles.mySubsTitle}>{t("subRev")}</div>}
      <p className={styles.mySubsTitle}>{t("subListTitle")}</p>
      <p className={styles.mySubsListTitle}>{t("mySubs")}</p>
      <div className={styles.subsListWrapper}>
        {userData?.has_monthly_subscription || userData?.has_yearly_subscription ? (
          <>
            {(() => {
              const now = new Date();

              const validSubs = userData.subscriptions.filter(
                (sub: any) => sub?.is_active && new Date(sub.next_pay_at) > now,
              );

              if (validSubs.length === 0) return null;

              const subWithLatestPayment = validSubs.reduce((latest: any, current: any) => {
                const latestDate = new Date(latest.next_pay_at);
                const currentDate = new Date(current.next_pay_at);
                return currentDate > latestDate ? current : latest;
              });

              const currentId = subWithLatestPayment.product_name === "One month" ? 1 : 2;
              const currentSubItem = currentId === 1 ? subscriptionsList[0] : subscriptionsList[1];

              return (
                <MySubscriptionsCard
                  currentId={currentId}
                  nextPay={subWithLatestPayment.next_pay_at}
                  currentSubItem={currentSubItem}
                />
              );
            })()}
          </>
        ) : (
          <MySubscriptionsCard
            currentId={0}
            nextPay={nextPay}
            clickHandler={() => navigate(ROUTES.DISCOUNT)}
            currentSubItem={subscriptionsList.find((item: any) => item.id === planId)}
          />
        )}
      </div>
      <div className={styles.mySubsBottomMenu}>
        {(userData?.has_monthly_subscription || userData?.has_yearly_subscription) && (
          <p onClick={removeSubscriptionHandler}>{t("removePayment")}</p>
        )}
      </div>
    </div>
  );
};

export default MySubscriptions;
